module.exports = __webpack_public_path__ + "media/images/emblems/Woelflinswil-blason-132d57e936169349d047687a184b54ed.png";